import { CircularProgress } from "@mui/material";
import React from "react";
import Chart from "react-apexcharts";

const GradientDonut = ({ label, value, color }) => {
  const options = {
    chart: {
      type: "radialBar",
    },
    tooltip: {
      enabled: true,
      fillSeriesColor: false,
      y: {
        formatter: (val) => `${val}% complete`,
      },
      custom: function ({ seriesIndex, dataPointIndex, w }) {
        const completed = w.config.series[0];
        const incomplete = 100 - completed;
        return `<div style="padding: 10px;">
            <strong>${label}</strong><br/>
            <span>Completed: ${completed}%</span><br/>
            <span>Incomplete: ${incomplete}%</span>
          </div>`;
      },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "50%",
        },
        track: {
          background: "#e0dede",
          strokeWidth: "100%",
        },
        dataLabels: {
          show: true,
          name: {
            show: true,
            fontSize: "16px",
            offsetY: 30,
            color: "#444",
          },
          value: {
            show: true,
            fontSize: "24px",
            fontWeight: 700,
            color: "#111",
            offsetY: -15,
          },
        },
        animate: {
          enabled: true,
          easing: "easeinout",
          speed: 1000,
          dynamicAnimation: {
            enabled: true,
            speed: 800,
          },
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "horizontal",
        gradientToColors: [color],
        stops: [0, 100],
      },
    },
    colors: [color],
    labels: [label],
  };

  return (
    <Chart options={options} series={[value]} type="radialBar" height={270} />
  );
};

const RadialBarChart = ({
  programmesData,
  is_show_dashbord,
  isHarmonyLoading,
}) => {
  const categoryColors = {
    mindset: "#09ADC0",
    workout: "#F47F23",
    food: "#EC2A90",
  };

  const labelMapping = {
    mindset: "Mindset",
    workout: "Workout",
    food: "Nutrition",
  };

  const defaultCategories = ["mindset", "workout", "food"];

  const categories =
    programmesData && Object.keys(programmesData).length > 0
      ? Object.entries(programmesData).map(([key, data]) => ({
          label:
            labelMapping[key] || key.charAt(0).toUpperCase() + key.slice(1),
          value: Math.round(data.percentage || 0),
          color: categoryColors[key] || "#888",
        }))
      : defaultCategories.map((key) => ({
          label: labelMapping[key],
          value: 0,
          color: categoryColors[key],
        }));

  return (
    <>
      {is_show_dashbord ? (
        <div className="row justify-content-center">
          {categories.map((item, index) => (
            <div key={index} className="col-md-4" style={{ minHeight: 280 }}>
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100%" }}
              >
                {isHarmonyLoading ? (
                  <CircularProgress />
                ) : (
                  <GradientDonut
                    label={item.label}
                    value={item.value}
                    color={item.color}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="container-fluid p-0">
          <div className="row justify-content-center text-center">
            {categories.map((item, index) => (
              <div key={index} className="col-md-4">
                <div className="card shadow border-0 rounded-4 p-3">
                  <GradientDonut
                    label={item.label}
                    value={item.value}
                    color={item.color}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default RadialBarChart;
